import { VoyagePerformanceScreen } from '@felix/ui';
import { useTranslation } from 'react-i18next';
import { Shell } from '../components/Shell.js';
import { officeVoyageSource } from '../voyage-source.js';

/** Voyage Performance: ortak ekran (ADR 0022 §4); performans gönderilmiş raporlardan, salt okunur. */
export function VoyagePerformancePage() {
  const { t } = useTranslation();
  return (
    <Shell title={t('voyage.performance.title')}>
      <VoyagePerformanceScreen source={officeVoyageSource} />
    </Shell>
  );
}
